export { default as Title } from './Title';
